import Header from '../components/Header';
import HeroV2 from '../components/HeroV2';
import FeaturedTemplates from '../components/FeaturedTemplates';
import ServicesPreview from '../components/ServicesPreview';
import Process from '../components/Process';
import BeforeAfter from '../components/BeforeAfter';
import Stats from '../components/Stats';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import CTABanner from '../components/CTABanner';
import Partners from '../components/Partners';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroV2 />
        <FeaturedTemplates />
        <ServicesPreview />
        <Process />
        <BeforeAfter />
        <Stats />
        <About />
        <Testimonials />
        <CTABanner />
        <Partners />
        <Pricing />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
